module.exports = __webpack_public_path__ + "static/img/WechatIMG85.0647bcc9.png";